export const RECORDING_STATUS = Object.freeze({
  not_started: "Not Started",
  recording: "Recording",
  paused: "Paused",
  stopped: "Stopped",
  finished: "Finished",
  error: "Error",
  started: "Starting in....",
});

export const MAX_RECORDING_TIME = 5 * 60;
